import styled from '@emotion/styled';
import { StyledScroll } from './StyledScroll';
import { COLORS, DOTTED_FOCUS, MAIN_CONTENT_SIZE } from '../../constants';
import { exemplarContentStyles, exemplarTitleStyles } from '../../constants/exemplar';

export const StyledTextEditorModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  width: 100%;
  z-index: 1000;
`;

export const StyledTextEditorContent = styled.div`
  height: calc(100% - 30px);
  margin: 0 auto;
  padding-bottom: 30px;
  max-width: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const StyledTextEditorContentInner = styled.div`
  overflow: auto;
  padding: 15px 0 64px 0;
  ${StyledScroll}
`;

export const StyledEditorWrapper = styled.div`
  padding: 21px;
  display: flex;
  width: 100%;

  counter-reset: editor;
`;

export const StyledEditorSide = styled.div`
  width: 50%;
`;

interface TextEditor {
  isHidden?: boolean;
  headingColor?: string;
  listColor?: string;
  stage?: string;
  subHeadingFontSize?: number;
}

export const StyledTextEditor = styled.div<TextEditor>`
  ${({ stage }) => exemplarContentStyles(stage)}
  line-height: 1.45;
  width: 100%;
  border: 1px dashed ${COLORS.lightSilver};
  padding: 16px 20px;
  ${({ isHidden }) => isHidden && 'visibility: hidden;'}

  h2 {
    margin: 0;
    color: ${({ headingColor }) => headingColor || COLORS.black};
    line-height: 37px;
    ${({ stage }) => exemplarTitleStyles(stage)};
  }

  h3 {
    margin: 6px 0;
    color: ${({ headingColor }) => headingColor || COLORS.black};
    font-size: ${({ subHeadingFontSize }) => (subHeadingFontSize ? subHeadingFontSize : 23)}px;
    line-height: 1.48;
    letter-spacing: 0.46px;
    font-weight: 700;
  }

  ul {
    margin: 5px 0;
    padding-inline-start: 20px;

    li {
      margin: 10px 0 !important;
      padding-inline-start: 10px;

      ::marker {
        color: ${({ listColor }) => listColor || COLORS.black};
      }
    }
  }

  ol {
    li {
      ::before {
        color: ${({ listColor }) => listColor || COLORS.black};
        counter-increment: editor;
        content: counter(editor) '. ';
      }
    }
  }

  .public-DraftStyleDefault-block {
    margin: 0;
  }

  .text-editor-toolbar {
    position: absolute !important;
    z-index: 10;
    bottom: -67px;
    height: 42px;
    margin-left: -42px;
    padding: 0;
    border: none;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    user-select: none;
    box-shadow: 1px 1px 4px 0 rgba(0, 0, 0, 0.35);
    background-color: white;

    &.text-editor-toolbar-right {
      margin-left: -${MAIN_CONTENT_SIZE.S[0] / 2 + 21}px;
    }

    & > div {
      margin: 0;
    }

    @media (max-width: 930px) {
      left: 0;
      margin-left: 0 !important;
    }
  }

  .rdw-inline-wrapper {
    display: flex;
  }

  .text-editor-tool {
    position: relative;
    display: flex;
    align-items: center;
    border: none;
    border-radius: 0;
    background: none;
    outline: none;
    box-shadow: none;
    height: 42px;
    padding: 0 15px;
    margin: 0;
    transition:
      background 0.15s,
      border-color 0.15s,
      box-shadow 0.15s,
      color 0.15s;

    :hover,
    &.rdw-option-active {
      background: ${COLORS.veryLightPink};
    }

    &.rdw-option-disabled {
      cursor: not-allowed;
      opacity: 0.2;
    }

    ${DOTTED_FOCUS}

    &.sm-img img {
      padding: 4px 3px;
      width: 22px;
      height: 22px;
    }

    img {
      width: 24px;
      height: 24px;
    }
  }
`;

export const StyledTextEditorFooter = styled.div`
  width: 100%;
  max-width: 926px;
  margin: 0 auto;
  padding-top: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const StyledTextEditorToolbar = styled.div`
  background-color: white;
  box-shadow: 1px 1px 4px 0 rgba(0, 0, 0, 0.35);
  height: 42px;
`;
